/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 01:54:32
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiHidden - hide the cell or form element.
// true | false | inherit
@UITag.set()
export class uiHidden extends BaseUITag {
    appliedTo: EUITagTarget[] = [
        EUITagTarget.TableHeaderCellContainer,
        EUITagTarget.TableBodyCellContainer,
        EUITagTarget.FormElement,
    ];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean, EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: true

    /// set styles display: inherit / none
    parse(input: IUITagInput): IUITagResult | null {
        let rule: boolean | string = (this.parseRule(input) as any) ?? true;

        if (rule === "inherit") return null;

        return {
            styles: {
                display: rule === true ? "none" : null,
            },
        };
    }
}
